import { deleteTopic } from "@/api/topics";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface IProps {
    topicId: number;
}

export const DeleteTopicButton = ({ topicId }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: topicId,
        subject: "topic",
        mutationFn: deleteTopic,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-topics"],
            });
        },
    };

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, dialogProps);
    };

    return (
        <GridActionsCellItem
            icon={
                <Tooltip title="Delete Topic">
                    <Delete />
                </Tooltip>
            }
            label="Delete"
            onClick={handleDelete}
        />
    );
};
